import AirConditioner from '@/components/UI/svg/solar-calculator/AirConditioner';
import AngleGrinder from '@/components/UI/svg/solar-calculator/AngleGrinder';
import Blower from '@/components/UI/svg/solar-calculator/Blower';
import Camera from '@/components/UI/svg/solar-calculator/Camera';
import CarWasher from '@/components/UI/svg/solar-calculator/CarWasher';
import CircularSaw from '@/components/UI/svg/solar-calculator/CircularSaw';
import Custome from '@/components/UI/svg/solar-calculator/Custome';
import DesktopComputer from '@/components/UI/svg/solar-calculator/DesktopComputer';
import Drone from '@/components/UI/svg/solar-calculator/Drone';
import ElectricGrill from '@/components/UI/svg/solar-calculator/ElectricGrill';
import ElectricOven from '@/components/UI/svg/solar-calculator/ElectricOven';
import Kettle from '@/components/UI/svg/solar-calculator/Kettle';
import Laptop from '@/components/UI/svg/solar-calculator/Laptop';
import Light from '@/components/UI/svg/solar-calculator/Light';
import Microwave from '@/components/UI/svg/solar-calculator/Microwave';
import Minifridge from '@/components/UI/svg/solar-calculator/Minifridge';
import Phone from '@/components/UI/svg/solar-calculator/Phone';
import Projector from '@/components/UI/svg/solar-calculator/Projector';
import Refrigerator from '@/components/UI/svg/solar-calculator/Refrigerator';
import SpaceHeater from '@/components/UI/svg/solar-calculator/SpaceHeater';
import Speaker from '@/components/UI/svg/solar-calculator/Speaker';
import TV from '@/components/UI/svg/solar-calculator/TV';
import VacuumCleaner from '@/components/UI/svg/solar-calculator/VacuumCleaner';

export const NEW_VISION_SITE: string[] = ['us', 'ca', 'eu', 'uk', 'au'];

export enum SolarCalcPage {
    Step1,
    Step2,
    Step3,
    Step4,
    Step5,
}

export type Item = {
    webp?: any;
    img: any;
    text: string;
    key?: string;
    icon?: any;
};

export type ItemsMap = {
    [key in 'outdoor' | 'home' | 'work' | 'others']: {
        title: string;
        data: Item[];
    };
};

type Time = {
    h: string;
    m: string;
    t: number;
};

type ApplianceType = {
    key: string;
    i18n: string;
    desc: string;
    icon?: any;
    power: number;
    time: Time;
};

type ApplianceMapType = {
    [key: string]: ApplianceType;
};

const ApplianceMap: ApplianceMapType = {
    camera: {
        key: 'camera',
        i18n: 'camera',
        desc: '9W/3h/day',
        // icon: require(`@publicLocal/solar-calculator/icon/camera.svg`),
        icon: <Camera />,
        power: 9,
        time: { h: '03', m: '00', t: 3 },
    },
    light: {
        key: 'light',
        i18n: 'light',
        desc: '10W/6h/day',
        // icon: require('@publicLocal/solar-calculator/icon/light.svg'),
        icon: <Light />,
        power: 10,
        time: { h: '06', m: '00', t: 6 },
    },
    projector: {
        key: 'projector',
        i18n: 'projector',
        desc: '65W/3h/day',
        // icon: require('@publicLocal/solar-calculator/icon/projector.svg'),
        icon: <Projector />,
        power: 65,
        time: { h: '03', m: '00', t: 3 },
    },
    drone: {
        key: 'drone',
        i18n: 'drone',
        desc: '40W/30m/day',
        // icon: require('@publicLocal/solar-calculator/icon/drone.svg'),
        icon: <Drone />,
        power: 40,
        time: { h: '00', m: '30', t: 0.5 },
    },
    phone: {
        key: 'phone',
        i18n: 'phone',
        desc: '18W/8h/day',
        // icon: require('@publicLocal/solar-calculator/icon/phone.svg'),
        icon: <Phone />,
        power: 18,
        time: { h: '08', m: '00', t: 8 },
    },
    laptop: {
        key: 'laptop',
        i18n: 'laptop',
        desc: '60W/4h/day',
        // icon: require('@publicLocal/solar-calculator/icon/laptop.svg'),
        icon: <Laptop />,
        power: 60,
        time: { h: '04', m: '00', t: 4 },
    },
    minifridge: {
        key: 'minifridge',
        i18n: 'minifridge',
        desc: '60W/6h/day',
        // icon: require('@publicLocal/solar-calculator/icon/minifridge.svg'),
        icon: <Minifridge />,
        power: 60,
        time: { h: '06', m: '00', t: 6 },
    },
    speaker: {
        key: 'speaker',
        i18n: 'speaker',
        desc: '60W/4h/day',
        // icon: require('@publicLocal/solar-calculator/icon/speaker.svg'),
        icon: <Speaker />,
        power: 60,
        time: { h: '04', m: '00', t: 4 },
    },
    kettle: {
        key: 'kettle',
        i18n: 'kettle',
        desc: '1500W/1h/day',
        // icon: require('@publicLocal/solar-calculator/icon/kettle.svg'),
        icon: <Kettle />,
        power: 1500,
        time: { h: '01', m: '00', t: 1 },
    },
    air_conditioner: {
        key: 'air_conditioner',
        i18n: 'air_conditioner',
        desc: '1500W/2h/day',
        // icon: require('@publicLocal/solar-calculator/icon/air_conditioner.svg'),
        icon: <AirConditioner />,
        power: 1500,
        time: { h: '02', m: '00', t: 2 },
    },
    microwave: {
        key: 'microwave',
        i18n: 'microwave',
        desc: '700W/1h/day',
        // icon: require('@publicLocal/solar-calculator/icon/microwave.svg'),
        icon: <Microwave />,
        power: 700,
        time: { h: '01', m: '00', t: 1 },
    },
    refrigerator: {
        key: 'refrigerator',
        i18n: 'refrigerator',
        desc: '120W/24h/day',
        // icon: require('@publicLocal/solar-calculator/icon/refrigerator.svg'),
        icon: <Refrigerator />,
        power: 120,
        time: { h: '24', m: '00', t: 24 },
    },
    tv: {
        key: 'tv',
        i18n: 'tv',
        desc: '110W/4h/day',
        // icon: require('@publicLocal/solar-calculator/icon/tv.svg'),
        icon: <TV />,
        power: 110,
        time: { h: '04', m: '00', t: 4 },
    },
    vacuum_cleaner: {
        key: 'vacuum_cleaner',
        i18n: 'vacuum_cleaner',
        desc: '700W/2h/day',
        // icon: require('@publicLocal/solar-calculator/icon/vacuum_cleaner.svg'),
        icon: <VacuumCleaner />,
        power: 700,
        time: { h: '02', m: '00', t: 2 },
    },
    desktop_computer: {
        key: 'desktop_computer',
        i18n: 'desktop_computer',
        desc: '200W/4h/day',
        // icon: require('@publicLocal/solar-calculator/icon/desktop_computer.svg'),
        icon: <DesktopComputer />,
        power: 200,
        time: { h: '04', m: '00', t: 4 },
    },
    electric_oven: {
        key: 'electric_oven',
        i18n: 'electric_oven',
        desc: '1650W/1h/day',
        // icon: require('@publicLocal/solar-calculator/icon/electric_oven.svg'),
        icon: <ElectricOven />,
        power: 1650,
        time: { h: '01', m: '00', t: 1 },
    },
    space_heater: {
        key: 'space_heater',
        i18n: 'space_heater',
        desc: '1500W/1h/day',
        // icon: require('@publicLocal/solar-calculator/icon/space_heater.svg'),
        icon: <SpaceHeater />,
        power: 1500,
        time: { h: '01', m: '00', t: 1 },
    },
    circular_saw: {
        key: 'circular_saw',
        i18n: 'circular_saw',
        desc: '1400W/1h/day',
        // icon: require('@publicLocal/solar-calculator/icon/circular_saw.svg'),
        icon: <CircularSaw />,
        power: 1400,
        time: { h: '01', m: '00', t: 1 },
    },
    angle_grinder: {
        key: 'angle_grinder',
        i18n: 'angle_grinder',
        desc: '980W/1h/day',
        // icon: require('@publicLocal/solar-calculator/icon/angle_grinder.svg'),
        icon: <AngleGrinder />,
        power: 980,
        time: { h: '01', m: '00', t: 1 },
    },
    electric_grill: {
        key: 'electric_grill',
        i18n: 'electric_grill',
        desc: '900W/1h/day',
        // icon: require('@publicLocal/solar-calculator/icon/electric_grill.svg'),
        icon: <ElectricGrill />,
        power: 900,
        time: { h: '01', m: '00', t: 1 },
    },
    car_washer: {
        key: 'car_washer',
        i18n: 'car_washer',
        desc: '600W/30m/day',
        // icon: require('@publicLocal/solar-calculator/icon/car_washer.svg'),
        icon: <CarWasher />,
        power: 600,
        time: { h: '00', m: '30', t: 0.5 },
    },
    blower: {
        key: 'blower',
        i18n: 'blower',
        desc: '700W/1h/day',
        // icon: require('@publicLocal/solar-calculator/icon/blower.svg'),
        icon: <Blower />,
        power: 700,
        time: { h: '01', m: '00', t: 1 },
    },
    custome: {
        key: 'custome',
        i18n: 'custome',
        desc: '0W/1Hour/day',
        // icon: require('@publicLocal/solar-calculator/icon/custome.svg'),
        icon: <Custome />,
        power: 0,
        time: { h: '00', m: '00', t: 0 },
    },
};

const {
    camera,
    light,
    projector,
    drone,
    phone,
    laptop,
    minifridge,
    speaker,
    kettle,
    air_conditioner,
    microwave,
    refrigerator,
    tv,
    vacuum_cleaner,
    desktop_computer,
    electric_oven,
    space_heater,
    circular_saw,
    angle_grinder,
    electric_grill,
    car_washer,
    blower,
} = ApplianceMap;

export const custome = ApplianceMap?.custome;

export const getSceneAppliances = (scene: string, type?: string, locale?: string) => {
    const ApplianceSceneMap: any = {
        outdoor: {
            type1: [camera, light, projector, drone, phone, laptop, minifridge, speaker, kettle, air_conditioner, microwave],
            type2: [camera, projector, phone, laptop, speaker, kettle, drone, light],
        },
        home: [microwave, refrigerator, tv, vacuum_cleaner, desktop_computer, electric_oven, light, space_heater],
        work:
            locale === 'au'
                ? [circular_saw, angle_grinder, electric_grill, laptop, car_washer, blower, drone, speaker]
                : [circular_saw, angle_grinder, electric_grill, laptop, car_washer, blower],
        others: [camera, light, projector, drone, phone, laptop, minifridge, speaker, kettle, air_conditioner, microwave],
    };
    return type ? ApplianceSceneMap[scene][type] : ApplianceSceneMap[scene];
};

// 计算公式
export const calculateTotalPower = (allArr: any, selectedArr: any) => {
    let result = 0;
    allArr?.map((app: any) => {
        if (selectedArr.find((item: any) => item.key === app.key)) {
            result += app.power * app.time.t;
        }
    });
    return result / 1000;
};

// 给的图片素材有的有webp, 有的没有webp
const recommendBundleMap: any = {
    au: {
        outdoor_1: {
            type1: [
                {
                    productId: '7756518654150',
                    variantId: '42649688244422',
                    title: 'RIVER 2',
                    totalWeight: 3.5,
                    capacity: '256Wh (21.33Ah@12V) ',
                    output: '300W',
                    input: '110W, 11-30V 8A Max',
                    tips: [1, 2, 3],
                    hideConnection: true,
                    link: 'https://au.ecoflow.com/products/river-2-portable-power-station',
                },
                {
                    productId: '8418809053382',
                    variantId: '44377826328774',
                    title: 'RIVER 3 (10 ms UPS)',
                    otherText: 'UPS <10 ms',
                    totalWeight: 3.5,
                    capacity: '245Wh (76.8Ah@12V)',
                    output: '300W',
                    input: '11-30V, 8A, 110W Max',
                    tips: [1, 2, 3],
                    hideConnection: true,
                    link: 'https://au.ecoflow.com/products/river-3-ups',
                },
                {
                    productId: '8435565494470',
                    variantId: '44377923027142',
                    title: 'RIVER 3 Plus',
                    totalWeight: 4.7,
                    capacity: '286Wh (23.8Ah@12V)',
                    output: '600W',
                    input: '11-55V, 13A Max, 220W',
                    tips: [1, 2, 3],
                    hideConnection: true,
                    bestSeller: true,
                    link: 'https://au.ecoflow.com/products/ecoflow-river-3-plus-portable-power-station',
                },
            ],
            type2: [
                {
                    productId: '7756517146822',
                    variantId: '42768126181574',
                    title: 'DELTA 2',
                    capacity: '1024Wh (85Ah@12V)',
                    output: '1800W',
                    input: '11-60V, 15A, 500W max',
                    totalWeight: 12,
                    tips: [1, 2, 3],
                    hideConnection: true,
                    link: 'https://au.ecoflow.com/products/delta-2-portable-power-station',
                },
                {
                    productId: '8315583430854',
                    variantId: '44211129614534',
                    title: 'DELTA 3 (1500)',
                    capacity: '1536Wh (128Ah@12V)',
                    output: '1800W',
                    input: '11V-60V 500W Max',
                    totalWeight: 16.5,
                    tips: [1, 2, 3],
                    hideConnection: true,
                    link: 'https://au.ecoflow.com/products/delta-3-1500-portable-power-station',
                },
                {
                    productId: '8435739197638',
                    variantId: '44378294452422',
                    title: 'DELTA 3 Plus',
                    otherText: 'UPS <10 ms',
                    capacity: '1024Wh (85Ah@12V)',
                    output: '1800W',
                    input: '11V-60V 500W Max',
                    totalWeight: 12.5,
                    tips: [1, 2, 3],
                    hideConnection: true,
                    bestSeller: true,
                    link: 'https://au.ecoflow.com/products/ecoflow-delta-3-plus-portable-power-station',
                },
            ],
        },
        outdoor_2: {
            type1: [
                {
                    productId: '8462188118214',
                    variantId: '44457406922950',
                    title: 'RIVER 3 Max Plus',
                    capacity: '858Wh (71.5Ah@12V)',
                    output: '600W',
                    input: '11-55V, 13A Max, 220W',
                    totalWeight: 10.8,
                    tips: [1, 2, 3],
                    hideConnection: true,
                    link: 'https://au.ecoflow.com/products/ecoflow-river-3-max-plus-portable-power-station',
                },
                {
                    productId: '8462188118214',
                    variantId: '44457406955718',
                    title: 'RIVER 3 Max ',
                    capacity: '572Wh (47.7Ah@12V)',
                    output: '600W',
                    input: '11-55V, 13A Max, 220W',
                    totalWeight: 8.4,
                    tips: [1, 2, 3],
                    hideConnection: true,
                    link: 'https://au.ecoflow.com/products/ecoflow-river-3-max-plus-portable-power-station',
                },
                {
                    productId: '7756526584006',
                    variantId: '42673598824646',
                    title: 'RIVER 2 Pro',
                    capacity: '768Wh (64Ah@12V)',
                    output: '800W',
                    input: '220W, 11-50V 13A Max',
                    totalWeight: 8.25,
                    tips: [1, 2, 3],
                    hideConnection: true,
                    bestSeller: true,
                    link: 'https://au.ecoflow.com/products/river-2-pro-portable-power-station',
                },
            ],
            type2: [
                {
                    productId: '8435739197638',
                    variantId: '44378294452422',
                    title: 'DELTA 3 Plus',
                    otherText: 'UPS <10 ms',
                    capacity: '1024Wh (85Ah@12V)',
                    output: '1800W',
                    input: '11V-60V 500W Max',
                    totalWeight: 12.5,
                    tips: [1, 2, 3],
                    hideConnection: true,
                    link: 'https://au.ecoflow.com/products/ecoflow-delta-3-plus-portable-power-station',
                },
                {
                    productId: '8315583430854',
                    variantId: '44211129614534',
                    title: 'DELTA 3 (1500)',
                    capacity: '1536Wh (128Ah@12V)',
                    output: '1800W',
                    input: '11V-60V 500W Max',
                    totalWeight: 16.5,
                    tips: [1, 2, 3],
                    hideConnection: true,
                    link: 'https://au.ecoflow.com/products/delta-3-1500-portable-power-station',
                },
                {
                    productId: '7914502422726',
                    variantId: '43045698371782',
                    title: 'DELTA 2 Max',
                    capacity: '2048Wh (167Ah@12V)',
                    output: '2400W',
                    input: '11-60V 15A, single port 500W; dual port 1,000W',
                    totalWeight: 23,
                    tips: [2],
                    hideConnection: true,
                    bestSeller: true,
                    link: 'https://au.ecoflow.com/products/delta-2-max-portable-power-station',
                },
            ],
        },
        home: {
            type1: [
                {
                    productId: '7914502422726',
                    variantId: '44164118708422',
                    title: 'DELTA 2 Max Solar Generator (220W Solar Panel)',
                    capacity: '2048Wh (167Ah@12V)',
                    output: '2400W',
                    time: 'Fully charge in as fast as 11.6 hr',
                    totalWeight: 30,
                    tips: [2],
                    num: 1,
                    link: 'https://au.ecoflow.com/products/delta-2-max-portable-power-station',
                },
                {
                    productId: '7914502422726',
                    variantId: '43045698371782',
                    title: 'DELTA 2 Max',
                    capacity: '2048Wh (167Ah@12V)',
                    output: '2400W',
                    input: '11-60V 15A, single port 500W; dual port 1,000W',
                    totalWeight: 23,
                    tips: [2],
                    hideConnection: true,
                    bestSeller: true,
                    link: 'https://au.ecoflow.com/products/delta-2-max-portable-power-station',
                },
            ],
            type2: [
                {
                    productId: '8311879925958',
                    variantId: '44062870503622',
                    title: 'DELTA Pro 3',
                    capacity: '4096Wh (341Ah@12V)',
                    output: '4000W',
                    input: '2600W, Max\n2 Ports\nHPV: 30-150V/15A, 1600W Max\nLPV: 11-60V/20A, 1000W Max',
                    totalWeight: 51.5,
                    hideConnection: true,
                    link: 'https://au.ecoflow.com/products/ecoflow-delta-pro-3-portable-power-station',
                },
                {
                    productId: '8311879925958',
                    variantId: '44062870536390',
                    title: 'DELTA Pro 3 + Extra Battery',
                    capacity: '8192Wh (682.67Ah@12V)',
                    output: '4000W',
                    input: '2600W, Max\n2 Ports\nHPV: 30-150V/15A, 1600W Max\nLPV: 11-60V/20A, 1000W Max',
                    totalWeight: 84.5,
                    hideConnection: true,
                    bestSeller: true,
                    link: 'https://au.ecoflow.com/products/ecoflow-delta-pro-3-portable-power-station',
                },
            ],
        },
        work: {
            type1: [
                {
                    productId: '8462188118214',
                    variantId: '44457406922950',
                    title: 'RIVER 3 Max Plus',
                    capacity: '858Wh (71.5Ah@12V)',
                    output: '600W',
                    input: '11-55V, 13A Max, 220W',
                    totalWeight: 10.8,
                    tips: [1, 2, 3],
                    hideConnection: true,
                    link: 'https://au.ecoflow.com/products/ecoflow-river-3-max-plus-portable-power-station',
                },
            ],
            type2: [
                {
                    productId: '7220911505606',
                    variantId: '42736222142662',
                    title: 'DELTA Pro',
                    capacity: '3600Wh (300Ah@12V)',
                    output: '3600W',
                    input: '11-150V, 15A, 1600W Max',
                    totalWeight: 45,
                    hideConnection: true,
                    link: 'https://au.ecoflow.com/products/delta-pro-portable-power-station',
                },
                {
                    productId: '8311879925958',
                    variantId: '44062870536390',
                    title: 'DELTA Pro 3 + Extra Battery',
                    capacity: '8192Wh (682.67Ah@12V)',
                    output: '4000W',
                    input: '2600W, Max\n2 Ports\nHPV: 30-150V/15A, 1600W Max\nLPV: 11-60V/20A, 1000W Max',
                    totalWeight: 84.5,
                    hideConnection: true,
                    link: 'https://au.ecoflow.com/products/ecoflow-delta-pro-3-portable-power-station',
                },
            ],
        },
        others: {
            type1: [
                {
                    productId: '7776141770950',
                    variantId: '42649691652294',
                    title: 'RIVER 2 Solar Generator (110W Solar Panel)',
                    capacity: '256Wh (21.33Ah@12V) ',
                    output: '300W',
                    time: 'Fully charge in as fast as 2.9 hr',
                    totalWeight: 7.5,
                    tips: [1, 2, 3],
                    num: 1,
                    link: 'https://au.ecoflow.com/products/river-2-110w-portable-solar-panel',
                },
                {
                    productId: '7776162480326',
                    variantId: '43846608257222',
                    title: 'RIVER 2 Max Solar Generator (160W Solar Panel)',
                    capacity: '512Wh (42.66Ah@12V) ',
                    output: '500W',
                    time: 'Fully charge in as fast as 4 hr',
                    totalWeight: 11.2,
                    tips: [1, 2, 3],
                    bestSeller: true,
                    num: 1,
                    link: 'https://au.ecoflow.com/products/river-2-max-160w-portable-solar-panel',
                },
            ],
            type2: [
                {
                    productId: '7812370268358',
                    variantId: '42994591006918',
                    title: 'DELTA 2 Solar Generator (220W Solar Panel)',
                    capacity: '1024Wh (85Ah@12V)',
                    output: '1800W',
                    time: 'Fully charge in as fast as 5.8 hr',
                    totalWeight: 19,
                    tips: [1, 2],
                    num: 1,
                    link: 'https://au.ecoflow.com/products/delta-2-solar-generator-pv220w',
                },
                {
                    productId: '7914502422726',
                    variantId: '44164118708422',
                    title: 'DELTA 2 Max Solar Generator (220W Solar Panel)',
                    capacity: '2048Wh (167Ah@12V)',
                    output: '2400W',
                    time: 'Fully charge in as fast as 11.6 hr',
                    totalWeight: 30,
                    tips: [2],
                    num: 1,
                    link: 'https://au.ecoflow.com/products/delta-2-max-portable-power-station',
                },
                {
                    productId: '8435739721926',
                    variantId: '44378295599302',
                    title: 'DELTA 3 Plus Solar Generator (220W Solar Panel)',
                    capacity: '1024Wh (85Ah@12V)',
                    output: '1800W',
                    time: 'Fully charge in as fast as 4.8 hr',
                    totalWeight: 19.5,
                    tips: [1, 2],
                    num: 1,
                    bestSeller: true,
                    link: 'https://au.ecoflow.com/products/ecoflow-delta-3-plus-solar-generator-200w-solar-panel',
                },
            ],
        },
    },
};

export const getRecommendBundle = (locale: string, scene: string, type: string) => recommendBundleMap[locale][scene][type];
